export default __webpack_public_path__ + "static/media/future-bass-beat-4999.737a08a7.mp3";